export { default as useProductsIndexContentCategoriesFilters } from './useProductsIndexContentCategoriesFilters';
